// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__ftkOH","employee-header-item":"Header_employee-header-item__WeMdg"};